if (!customElements.get('cc-video')) {
    customElements.define(
      'cc-video',
      class CCVideo extends HTMLElement {
        constructor() {
          super();
          this.href = null || this.getAttribute('data-href')
          this.video = this.querySelector('video');
          this.init();
        }
        init() {
          this.controls();
          if (this.video) {
            // fire mouse in and out event for desktop
            if(window.innerWidth >= 1023){
              this.video.addEventListener('mouseover', this.playVideo.bind(this))
              this.video.addEventListener('mouseout', this.pauseVideo.bind(this))
            }
            if(this.href) {
              this.video.addEventListener('click', this.redirect.bind(this))
            }
          }
        }
        redirect(e) {
          let filterLink = document.createElement('a')
          filterLink.setAttribute('href', this.href)
          filterLink.click();
        }
        controls() {
          this.videoPlayBtn = this.querySelector('.video__toggle__play');
          this.videoPauseBtn = this.querySelector('.video__toggle__pause');
          this.video = this.querySelector('video');

          // play/pause buttons
          this.videoPlayBtn.addEventListener('click', (e) => {
            this.videoPlayBtn.classList.add('hidden');
            this.videoPauseBtn.classList.remove('hidden');
            this.querySelector('video').play();
          });
          this.videoPauseBtn.addEventListener('click', (e) => {
            this.videoPauseBtn.classList.add('hidden');
            this.videoPlayBtn.classList.remove('hidden');
            this.querySelector('video').pause();
          });
        }
        playVideo() {
          if (window.innerWidth > 768 && this.video.paused) {
            !this.video.getAttribute('playsinline') ? this.video.setAttribute('playsinline', true) : null;
            this.video.play();
            !this.videoPlayBtn.classList.contains('hidden') ? this.videoPlayBtn.classList.add('hidden') : null;
            this.videoPauseBtn.classList.contains('hidden') ? this.videoPauseBtn.classList.remove('hidden') : null;
          }
          if (window.innerWidth <= 768 && this.video.paused) {
            !this.video.getAttribute('playsinline') ? this.video.setAttribute('playsinline', true) : null;
            this.video.play();
            !this.videoPlayBtn.classList.contains('hidden') ? this.videoPlayBtn.classList.add('hidden') : null;
            this.videoPauseBtn.classList.contains('hidden') ? this.videoPauseBtn.classList.remove('hidden') : null;
          }
        }
        pauseVideo() {
          if (window.innerWidth < 768 && !this.video.paused) {
            this.video.pause();
            this.videoPlayBtn.classList.contains('hidden') ? this.videoPlayBtn.classList.remove('hidden') : null;
            !this.videoPauseBtn.classList.contains('hidden') ? this.videoPauseBtn.classList.add('hidden') : null;
          }
          if (window.innerWidth >= 768 && !this.video.paused) {
            this.video.pause();
            this.videoPlayBtn.classList.contains('hidden') ? this.videoPlayBtn.classList.remove('hidden') : null;
            !this.videoPauseBtn.classList.contains('hidden') ? this.videoPauseBtn.classList.add('hidden') : null;
          }
        }
      }
    );
  }